// @flow

import * as React from 'react';

import { compose } from 'redux';

import { withForm } from 'gandi.react-form';

import ClaimsForm from './ClaimsForm';
import type { ClaimsFormProps } from './ClaimsForm';

import formValidation from './validation';

export default (compose(
  withForm({
    form: ClaimsForm.FORM_ID,
    validate: formValidation,
  }),
)(ClaimsForm): React.ComponentType<ClaimsFormProps>);
